// extracted by mini-css-extract-plugin
export var alertIcon = "_nx-0";